module.exports = __webpack_public_path__ + "static/img/connect-img-append.c5f14145.png";